<img src="{{ meteoDirect.imageMeteoActuel }}" alt="Météo du jour : {{ meteoDirect.meteoActuel }}">